<template>
    <span>
        <template v-if="discount">
            <span style="font-size:1em;"
                  class="badge badge-pill badge-secondary  mr-1 "> {{ decToDisc(discount)}} </span>
        </template>
        <template v-if="customerOffer">
            <span style="font-size:1em; "
                  class="badge badge-pill badge-primary mr-1"> {{ decToDisc(customerOffer)}}</span>
        </template>
        <template v-if="!customerOffer && !discount"> <div class="text-md-center">-</div></template>
    </span>
</template>

<script>
    import Product from '@/assets/product'

    export default {
        props: {
            discount: Number,
            customerOffer: Number,

        },
        name: "Discount",
        methods: {
            decToDisc(discount) {
                return Product.toPercent(discount, 2)
            },
        }
    }
</script>

<style scoped>



</style>


// WEBPACK FOOTER //
// src/components/Discount.vue